module.exports = __webpack_public_path__ + "static/media/poste_19.afe1cc88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_19.jpg
// module id = 247
// module chunks = 0